








































import {Component, Mixins, Prop} from 'vue-property-decorator'
import {$, PageCollection} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import CargaCollection from '@/model/collection/CargaCollection'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import * as Helper from '@/helpers/custom.helper'
import DeliveryCsvNotasEmAtraso from '@/model/resource/DeliveryCsvNotasEmAtraso'

const metaInfo = () => ({
  title: $.t('view.get.deliveryGetNotasEmAtrasoListView.title'),
})

@Component({})
export default class DeliveryGetNotasEmAtrasoListView extends Mixins(MixinFilter) {
  @Prop({type: String, default: null}) hash!: string | null

  AppConfig = AppConfig

  collection = new CargaCollection({}, `/user/carga/notas-atraso`)

  async created() {
      const hash = this.hash ? encodeURIComponent(this.hash) : undefined
      this.collection.filter = {hash}
      $.await.done('query')
  }

  async downloadData(xlsx: boolean) {
    const hash = this.hash ? encodeURIComponent(this.hash) : undefined

    if (!xlsx) {
      const csv = new PageCollection(DeliveryCsvNotasEmAtraso, {hash}, null, null)
      csv.endpoint = '/user/carga/notas-atraso'

      const fetch = async () => await csv.search()
      await $.await.run(fetch, 'download')
      csv.downloadCsv($.t('view.get.deliveryGetNotasEmAtrasoListView.title'))
    } else {
      await $.await.run(() => Helper.downloadXlsx(
          $.t('view.get.deliveryGetNotasEmAtrasoListView.title'),
          '/user/carga/notas-atraso',
          {hash},
          DeliveryCsvNotasEmAtraso,
          'DeliveryCsvNotasEmAtraso',
      ), 'download')
    }
  }
}
